import { createSlice } from '@reduxjs/toolkit'
import { fetchNearbyPOIsAndMap, fetchPOIById } from './poiThunks'
import { POIState } from './types'

const initialState: POIState = {
  active: {
    data: null,
    loading: false,
    error: null,
  },
  nearby: {
    data: null,
    loading: false,
    error: null,
  },
}

const poiSlice = createSlice({
  name: 'poi',
  initialState,
  reducers: {
    clearNearbyPOIs: (state) => {
      state.nearby.data = null
      state.nearby.error = null
      state.nearby.loading = false
    },
    clearActivePOI: (state) => {
      state.active.data = null
      state.active.error = null
      state.active.loading = false
    },
  },
  extraReducers: (builder) => {
    builder
      // Nearby POIs
      .addCase(fetchNearbyPOIsAndMap.pending, (state) => {
        state.nearby.loading = true
        state.nearby.error = null
      })
      .addCase(fetchNearbyPOIsAndMap.fulfilled, (state, action) => {
        state.nearby.loading = false
        state.nearby.data = action.payload?.pois || []
      })
      .addCase(fetchNearbyPOIsAndMap.rejected, (state, action) => {
        state.nearby.loading = false
        state.nearby.error = action.payload?.toString() as string
        state.nearby.data = []
      })

      // Active POI
      .addCase(fetchPOIById.pending, (state) => {
        state.active.loading = true
        state.active.error = null
      })
      .addCase(fetchPOIById.fulfilled, (state, action) => {
        state.active.loading = false
        state.active.data = action.payload?.poi
      })
      .addCase(fetchPOIById.rejected, (state, action) => {
        state.active.loading = false
        state.active.error = action.payload as string
        state.active.data = null
      })
  },
})

export const { clearNearbyPOIs, clearActivePOI } = poiSlice.actions

export default poiSlice.reducer
